import type {ActionsObservable} from 'redux-observable';
import {Observable} from 'rxjs';
import {switchMap, merge, filter, map, catchError} from 'rxjs/operators';

import {transformDataForReport} from 'nutshell-core/json-to-report-data';

import {
    updateLandingPagesReportTableData,
    updateLandingPagesReportChartData,
    updateLandingPagesSummaryStats,
    failLandingPagesReportChartData,
    // @ts-expect-error
    LandingPagesReportDataRequestedAction,
} from './pages-actions';
// @ts-expect-error
import {getLandingPagesReportPostParams, LandingPagesReportPostParams} from './pages-utils';

export const requestLandingPagesReportDataEpic = (action$: ActionsObservable<any>) =>
    action$.ofType('LANDING_PAGES_REPORT_DATA_REQUESTED').pipe(
        switchMap((action: LandingPagesReportDataRequestedAction) => {
            const {reportParams, filters} = action.payload;
            const params = getLandingPagesReportPostParams(reportParams, filters);

            const requestStream = Observable.from(fetchData(params));
            const currentResultStream = requestStream.pipe(map((res) => res[0]));
            const reportDataStream = requestStream.pipe(map(transformDataForReport));

            const reportTableDataStream = reportDataStream.pipe(
                map(({tableData}) => updateLandingPagesReportTableData(tableData))
            );

            const reportChartDataStream = reportDataStream.pipe(
                map((data) => data.chartData),
                filter((chartData) => Boolean(chartData)),
                map((chartData) => updateLandingPagesReportChartData({chartData}))
            );

            const summaryStatStream = currentResultStream.pipe(
                map((currentResult) => updateLandingPagesSummaryStats(currentResult.meta))
            );

            return reportChartDataStream.pipe(
                merge(summaryStatStream.pipe(merge(reportTableDataStream))),
                catchError((err) => Observable.of(failLandingPagesReportChartData(err)))
            );
        })
    );

function fetchData(params: LandingPagesReportPostParams) {
    return Promise.all([fetchLandingPagesReportData(params)]);
}

function fetchLandingPagesReportData(params: LandingPagesReportPostParams): Promise<any> {
    const url = '/rest/landingpages/report';
    const ajaxParams = {
        url,
        dataType: 'json',
        data: params,
    } as const;

    return $.ajax(ajaxParams) as any; // This is how we have to convince flow that the response is a ReportsResponse
}
